import React from "react";
import "../App.css";
//import BoardElements from "./crossword/BoardElements";
import BoardElementsJson from "./crossword/BoardElementsJson";
import QuestionsRetrieval from "./questionnaire/QuestionsRetrieval";
import ShareButton from "./ShareButton";
import AddToHomeScreenButton from "./AddToHomeScreenButton";

const Main = () => {

  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate()

  const today = month + "-" + day + "-" + year;

  return (
    <div>
      <div className="mainWrapper">
        <div className="main">
          {/*<h1 style={{textAlign:'center'}}><img src="logo512.webp" alt="Today's mini crossword logo" title="Today's mini crossword company's logo" width='60' height='60' /> Today's Mini Crossword</h1>*/}
          {/*<h2 style={{fontSize:'1.5rem',textAlign:'center'}}>🧩 A New Crossword Every Day</h2>*/}
          <h2 style={{fontSize:'1.5rem',textAlign:'center'}}><img src="logo512.webp" alt="Today's mini crossword logo" title="Today's mini crossword company's logo" width='40' height='40' /> Today's Mini Crossword</h2>
          <h3 style={{textAlign:'center'}}>({today})</h3>
          {/*<BoardElements />*/}
          <BoardElementsJson/>
          <div style={{textAlign:'center'}}>
            <ShareButton/>
             <AddToHomeScreenButton/>
          </div>
         
         <QuestionsRetrieval/>
         {/* <DataCollectionForm/>*/}
        </div> 
      </div>
      <div className="crosswordsBenefitsContainer">
        <div className="flex-items">
          <h2><u>What's the benefit of solving today's mini crossword puzzle?</u></h2>
        </div>
        <div className="flex-items">
          <img className="media" src="todays-mini-crossword-grid.webp" alt="today's mini crossword grid" width="720" height="540"/>
        </div>
        <div className="flex-item">
          <p> 😶‍🌫️ <b>Say Goodbye to Brain Fog!:</b> Regularly solving a mini crossword puzzle can help you stay mentally sharp, boosting memory, attention, and processing speed. This means you'll be more focused, productive, and able to tackle challenges with confidence.</p>
          <p> 🗣️ <b>Expand Your Vocabulary and Communication Skills:</b> Daily mini crossword puzzle games expose you to new words, phrases, and language patterns, expanding your vocabulary and improving communication skills. You'll be able to express yourself more effectively, both in writing and conversation.</p>
          <p> 🧘‍♀️ <b>Reduce Stress and Boost Mood</b>: Engaging in a fun and challenging activity like the today's mini crossword puzzle can help reduce stress and improve mood by providing a sense of accomplishment and confidence.</p>
          <p> 🧠 <b>Improve Focus and Concentration</b>: Mini crossword puzzles require focus and concentration to solve, which can translate to improved productivity and better time management skills. You'll be able to prioritize tasks more effectively and stay on top of your work or school responsibilities.</p>
          <p> 🩺 <b>Protect Your Brain's Health</b>: Regular engagement in mentally stimulating activities like solving crossword puzzles may help delay cognitive decline and even reduce the risk of age-related diseases like Alzheimer's.</p>
          <p> ⏱️ <b>Only 5 minutes are required!</b>: Since these are mini crossword puzzles, you'll need only 5 minutes to feel relaxed!</p>
          <p> 🎁  For quiet moments, discover the world of OwlBooksHouse mini crossword puzzle books ⬇️⬇️⬇️</p>
        </div>
      </div>
        <p style={{textAlign:'center'}}>🧩 <cite>A new crossword every day keeps the doctor away!</cite></p>
      </div>
  );
};

export default Main;
